import type {
	DatovkaApiType,
	OsobyFyzickaOsobaDto,
	OsobyPodnikatelDto,
} from '@gov-nx/api';
import type { useIdentity } from '@gov-nx/auth/common';
import type { RezaSwitcherType } from '@gov-nx/core/hooks';
import { type FormWizardHook } from '@gov-nx/core/hooks';
import type { PageContextControls } from '../../types/page.types';
import type {
	PpdfSouhlasyUdeleniFormStep1,
	PpdfSouhlasyUdeleniStep1,
} from './useFormStep1';
import type {
	AgendaDataSelectedLabels,
	PpdfSouhlasyUdeleniFormStep2,
	PpdfSouhlasyUdeleniStep2,
} from './useFormStep2';
import type {
	PpdfSouhlasyUdeleniFormStep3,
	PpdfSouhlasyUdeleniStep3,
} from './useFormStep3';

export interface PpdfSouhlasyFormControls extends PageContextControls {
	initialLoading: boolean;
	createLoading: boolean;
	saveLoading: boolean;
	deleteLoading: boolean;
}

export enum PpdfSouhlasyTypOsobyEnum {
	FO = 'FO',
	PO = 'PO',
}

export type ZapisForm = PpdfSouhlasyUdeleniStep1 &
	PpdfSouhlasyUdeleniStep2 &
	PpdfSouhlasyUdeleniStep3;

export interface PpdfConsentsUdeleniContext {
	wizard: FormWizardHook<ZapisForm>;
	step1: PpdfSouhlasyUdeleniFormStep1;
	step2: PpdfSouhlasyUdeleniFormStep2;
	step3: PpdfSouhlasyUdeleniFormStep3;
	isLoading: boolean;
	noValuesForSharedAgendaData: boolean;
	isSubmitting: boolean;
	person?: OsobyFyzickaOsobaDto;
	rosContacts: OsobyPodnikatelDto[];
	isNew: boolean;
	isLowAuthorization: boolean;
	isAuthorizationEnforced: boolean;
	selectedLabels: AgendaDataSelectedLabels;
	submit: (onSuccess?: () => void) => void;
	isPOTabVisible: boolean;
	loginInfo: ReturnType<typeof useIdentity>;
	getRosContactByDataBoxId: (
		datBoxId: string
	) => OsobyPodnikatelDto | undefined;
	dataBoxes: DatovkaApiType[];
	consentValidityInterval: PpdfSouhlasyUdeleniStep2['consentValidityInterval'];
	rezaSwitcher: RezaSwitcherType;
}
